import {AppActions, RootState} from 'app/rootReducer'
import Toast from 'components/Basic/Toast'
import {translations} from 'definitions'
import {
  HTTP_STATUS_CODE,
  DEFAULT_DATE_WITH_TIME_FORMAT,
} from 'definitions/constant'
import {parseAnalyticsDetailRequestPayload} from 'features/Analytics/helpers'
import {format} from 'date-fns'
import {nanoid} from 'nanoid'
import {Epic} from 'redux-observable'
import {concat, from, of} from 'rxjs'
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  switchMap,
  tap,
} from 'rxjs/operators'
import {i18n} from 'i18n'
import {AnalyticsService} from 'services/api'
import {withDownloadInProgressToast} from '../downloadInProgressToast'
import {
  downloadViolationsLogs,
  downloadViolationsLogsFailure,
  downloadViolationsLogsSuccess,
} from './actions'

export const violationsLogsDownloadEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = (action$, state$) =>
  action$.pipe(
    filter(downloadViolationsLogs.match),
    switchMap(() => {
      const requestBody = {
        ...parseAnalyticsDetailRequestPayload(state$),
        dateTime: format(new Date(), DEFAULT_DATE_WITH_TIME_FORMAT),
      }
      const userEmail = requestBody.filter?.filterDetails?.userEmail
      const hasDetailFilters = Boolean(
        requestBody.filter?.policyType?.length ||
          requestBody.filter?.filterDetails?.category ||
          requestBody.filter?.filterDetails?.classifications?.length,
      )
      const getNoViolationsMessage = (): string => {
        if (hasDetailFilters)
          return i18n.t(
            'analytics:ANALYTICS_DOWNLOAD_NO_VIOLATIONS_WITH_FILTERS',
          )
        if (userEmail)
          return i18n.t('analytics:ANALYTICS_DOWNLOAD_NO_VIOLATIONS_FOR_USER', {
            userEmail,
            interpolation: {escapeValue: false},
          })
        return i18n.t('analytics:ANALYTICS_DOWNLOAD_NO_VIOLATIONS')
      }
      return from(
        AnalyticsService.getAnalyticsDetail(requestBody, {download: true}),
      ).pipe(
        mergeMap(resp => {
          const {data, status} = resp
          const {fileUrl = ''} = data?.response || {}
          if (status === HTTP_STATUS_CODE.NO_CONTENT) {
            Toast({
              message: getNoViolationsMessage(),
              type: 'info',
              customId: `violations-download-no-results-${nanoid()}`,
              multipleToast: true,
            })
          }
          return [downloadViolationsLogsSuccess(fileUrl)]
        }),
        catchError(() => concat(of(downloadViolationsLogsFailure()))),
        withDownloadInProgressToast,
      )
    }),
  )

export const violationsLogsDownloadFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(downloadViolationsLogsFailure.match),
    tap(() =>
      Toast({
        message: translations.UNKNOWN_ERROR,
        type: 'error',
        multipleToast: true,
      }),
    ),
    ignoreElements(),
  )

export const violationsLogsDownloadEpics = [
  violationsLogsDownloadEpic,
  violationsLogsDownloadFailureEpic,
]
